import React, { useEffect, useState } from 'react'
import { useGetEmployeeStatus, useGetEODstatus, useReportingToPositionData, useRoles, useUpdateProfile, useUserProfile } from '../hooks/useEmployee';
import { Input, Label, Spinner } from 'reactstrap';
import { Btn } from '../../../AbstractElements';
import RouteDropdown from '../../../Component/BasicComponents/Dropdowns/RouteDropdown';
import { useGetRolesList } from '../../ProductCatalogue/NotificationRepo';
import CustomInput from '../../../Component/BasicComponents/CustomInput';
import { showToast } from '../../../utils/toastUtils';

const UserProfileModal=({EmployeeId,toggleModal}:any)=>{

    const {data:GetRoles}=useRoles({
        enabled:true,
        params:{
               start:1,
            length:30,
            search:'',
        }
    })

   const {data:GetUserProfileData,isLoading}=useUserProfile({
      enabled:true,
      params:{
        employeeId:EmployeeId
      }
    })

    // console.log('GetUserProfileData',GetUserProfileData?.data)
    // console.log('GETROLES',GetRoles?.data?.data)
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [role, setRole] = useState("");
    const [password, setPassword] = useState("");
    const [status, setStatus] = useState("");
    const [userId,setUserId]=useState('');
    const [empId,setEmpId]=useState('');

    useEffect(() => {
  if (GetUserProfileData?.data) {
    const profile = GetUserProfileData.data;
    setName(profile.Name || "");
    setEmail(profile.Email || "");
    setPhone(profile.Phone || "");
    setRole(profile.RoleId?.toString() || ""); // assuming RouteDropdown uses string id
    setPassword(profile.Password || "");
    // setStatus(profile.Status?.toString() || "");
    setEmpId(profile.EmployeeId || "");
    setUserId(profile.UserId || "")

    const statusText = profile.Status === 1 ? "Active" : "Inactive";
    setStatus(statusText);
  
    
  }
}, [GetUserProfileData]);

 const { mutate } = useUpdateProfile();
   
    const handleSubmit = (e: React.FormEvent) => {
      e.preventDefault();

      console.log('status',status)

      if(!role){
        showToast.warning("Role is required")
      }

       if(!name){
        showToast.warning("Full name is required")
      }

       if(!phone){
        showToast.warning("Phone no. is required")
      }
     
       if(!status){
        showToast.warning("Status is required")
      }

      const payload = {
      userId: userId,
      employeeId: empId,
      roleId: role,
      phone: phone,
      fullName: name,
      email: email,
      status: status=='Active'?1:0,
      password:password
      
    };

      mutate(payload,{onSuccess:()=>{

        toggleModal()
      }})

    };

 const FormattedRoleData = Array.isArray(GetRoles?.data?.data)
  ? GetRoles.data.data.map((item: any) => ({
      id: item.RoleId.toString(),
      label: item.RoleName,
    }))
  : [];

   const { data: EmployeeStatus } = useGetEmployeeStatus({
     enable: true,
   });

  const FormattedEmpStatus = Object.entries(EmployeeStatus?.data?.EmpStatus || {})
  .map(([key, value]) => ({
    id: String(value),       // ✅ ensure string
    label: String(value),  // ✅ already text like Active/Inactive
  }));


    return (
      <>
      {isLoading?(  <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "60vh" }}
        >
          <Spinner color="primary" style={{ width: "3rem", height: "3rem" }} />
          {/* <span className="ms-3">Loading SGPI Brands...</span> */}
        </div>
      
      ):(      <form onSubmit={handleSubmit} >
        {/* Second Line */}
       <div className="row mb-3">
        <div className="col-md-4 mt-2">
        
            <div className="form-input position-relative">

              <CustomInput
              label='Name'
                // type={show ? "text" : "password"}
                placeholder="Enter Name"
                onChange={(event) => setName(event.target.value)}
                value={name}
              />
            </div>
          </div>
            <div className="col-md-4 mt-2">
            <div className="form-input position-relative">
              <CustomInput
              label='Email'
              type='email'
                // type={show ? "text" : "password"}
                placeholder="Enter Email"
                onChange={(event) => setEmail(event.target.value)}
                value={email}
              />
            </div>
          </div>
           <div className="col-md-4 mt-2">
            {/* <Label className="col-form-label">Phone</Label> */}
            <div className="form-input position-relative">
              <CustomInput
              label='Phone'
              type='number'
              maxLength={10}
                // type={show ? "text" : "password"}
                placeholder="Enter Phone"
                onChange={(e) =>{const value = e.target.value.slice(0, 10); setPhone(value)}}
                value={phone}
              />
            </div>
          </div>
           <div className="col-md-4 mt-2">

            <div className="form-input position-relative">
              <CustomInput
              label='Password'
                type={"password"}
                placeholder="Enter Password"
                onChange={(event) => setPassword(event.target.value)}
                value={password}
              />
            </div>
          </div>
          <div className="col-md-4 mt-2">
          <RouteDropdown
            value={role}
            DropdownHeading="Role"
            options={FormattedRoleData || []}
            onChange={(value: any) => {
              setRole(value);
            }}
          />
          </div>
            <div className="col-md-4 mt-2">
          <RouteDropdown
            value={status}
            DropdownHeading="Status"
            options={FormattedEmpStatus || []}
            onChange={(value: any) => {
              console.log(value,'kya hai')
              setStatus(value);
            }}
          />
          </div>
          </div>

        {/* Buttons */}
        <div className="d-flex justify-content-start mt-3 gap-2">
          <Btn
            style={{ backgroundColor: "#43B9B2", color: "white" }}
            type="submit"
          >
            {"Submit"}
          </Btn>
          <Btn
            style={{
              backgroundColor: "#F9FAFC",
              color: "#000",
              border: "1px solid #E0E0E0",
            }}
            type="button"
            onClick={toggleModal}
          >
            Cancel
          </Btn>
        </div>
      </form>
          )
        }
        </>
    );
}

export default UserProfileModal